import ApiClient from "services/ApiClient";
import qs from "qs";

import { formatSortField } from "utils/FormatUtils";

const PAGE_SIZE = 10;

class TimeAndExpensesService extends ApiClient {
  getDashboardTE({ page = 1, pageSize = PAGE_SIZE, sortBy, searchFilter, companyId = "" }) {
    const query = {
      page,
      pageSize,
    };

    if (sortBy && sortBy.field && sortBy.direction !== "None") {
      query.SortFieldName = formatSortField(sortBy.field);
      query.SortDirection = sortBy.direction;
    }

    if (searchFilter) {
      query.Name = searchFilter;
    }

    if (companyId) {
      query.companyId = companyId;
    }

    return this.call({
      method: "get",
      url: `/dashboard/expenses?${qs.stringify(query)}`,
    });
  }

  getDashboardTEFilters(params) {
    return this.call({
      method: "get",
      url: `/dashboard/expenses/filters?${qs.stringify(params)}`,
    });
  }
}

export default new TimeAndExpensesService();
